import React from 'react'
import { Row } from 'react-bootstrap'
import FavoriteButton from '../FavoriteButton'

const TableButton = ({
  data,
  uischema,
  actionOrder,
  buttonList,
  buttonPosition,
  config = {},
}) => {
  const { isFavoriteModal } = config
  return (
    <Row sm="12" className="mb-2 mx-auto d-flex w-100">
      {!isFavoriteModal && (
        <div className="mr-1">
          <FavoriteButton uischema={uischema} config={config} data={data} />
        </div>
      )}
      {actionOrder.map(({ key = '' }, index) => {
        return (
          (
            <div key={key} className={buttonPosition[index]}>
              {buttonList[key]}
            </div>
          ) || <></>
        )
      })}
    </Row>
  )
}

export default TableButton
